import React from 'react'
import Icon from 'shared/ui/Icon'
import './CourseList.scss'

function CourseList() {
  return (
    <div className="course-list">
      <CourseListItem href="https://courses.reacttraining.com/p/react-hooks" iconName="react-color">
        React Hooks
      </CourseListItem>
      <CourseListItem
        href="https://courses.reacttraining.com/p/realtime-react-with-firebase"
        iconName="firebase-color">
        React with Firebase
      </CourseListItem>
      <CourseListItem
        href="https://courses.reacttraining.com/p/react-router-5"
        iconName="react-router-color">
        React Router 5
      </CourseListItem>
      <CourseListItem
        href="https://courses.reacttraining.com/p/javascript-the-react-parts"
        iconName="javascript-color">
        JavaScript, the React Parts
      </CourseListItem>
      <CourseListItem href="https://courses.reacttraining.com/p/classic-react" iconName="react-color">
        React Classic
      </CourseListItem>
      <CourseListItem href="https://courses.reacttraining.com" iconName="arrow-right" color="blue">
        And More
      </CourseListItem>
    </div>
  )
}

function CourseListItem({ href, iconName, children, ...props }) {
  return (
    <a className="course-list-item" href={href}>
      <Icon name={iconName} size={4} {...props} />
      <span>{children}</span>
    </a>
  )
}

export default CourseList
